module.exports = __webpack_public_path__ + "img/body-position-chart-slide5.0a479e18.gif";